import { SupportRequestsService } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/inference-client';
import type { SupportRequest } from '../model/support-request.types';

/** Where and on whose behalf the request is sent. Read at submit time, not from the form. */
export interface SubmissionContext {
  workspaceId: string;
  pageUrl: string;
  workspaceName?: string;
  organizationName?: string;
}

export async function submitSupportRequest(
  request: SupportRequest,
  context: SubmissionContext,
): Promise<void> {
  const headers = { 'x-selected-workspace-id': context.workspaceId };
  const attachmentIds = await uploadAttachments(request.attachments, headers);
  await SupportRequestsService.create({
    client: inferenceHttp,
    headers,
    body: {
      type: request.type,
      area: request.area,
      currentBehavior: request.currentBehavior,
      expectedBehavior: request.expectedBehavior,
      isBlocker: request.isBlocker ?? undefined,
      description: request.description,
      frequency: request.frequency ?? undefined,
      attachmentIds,
      pageUrl: context.pageUrl,
      workspaceName: context.workspaceName,
      organizationName: context.organizationName,
    },
    throwOnError: true,
  });
}

async function uploadAttachments(
  files: File[],
  headers: { 'x-selected-workspace-id': string },
): Promise<string[]> {
  if (files.length === 0) return [];
  const { data } = await SupportRequestsService.uploadAttachments({
    client: inferenceHttp,
    headers,
    body: { files },
    throwOnError: true,
  });
  return data.attachments.map((attachment) => attachment.id);
}
